/**
 * Created by lu on 2018/4/24.
 */
var nb = require('../nb');
var map = {
    header: {
        homepageText: '首页',
        brandText: '品牌',
        productText: '产品',
        serviceText: '服务',
        loginText: '登录',
        languageText: 'EN',
        productListText:'产品列表',
        orderText: '订单管理',
        invoiceText: '发票历史',
        accountText: '账户信息',
        addressText: '收货地址',
        logOffText: '退出登录',
        goCartText: '查看购物车',
        cartTitle: '购物车',
        saleTitle: '销售客服',
        saleName: '姓名：',
        salePhone: '电话：',
        saleEmail: '邮箱：',
        cartEmptyText: '购物车中没有商品，去看看心仪的商品吧！',
        cartList: {
            itemText: {
                numText: '数量：',
                priceText: '价格：'
            }
        }
    },
    notice:{
        noticeList:{
            items:[{
                text:'欢迎使用ASC电商平台，有任何问题请联系销售客服为您处理。'
            }]
        }
    },
    // sidebar:{
    //     console:'控制台',
    // },
    footer: {
        title1: '关于我们',
        link1_1: '公司简介',
        link1_1_url: 'http://www.asc-wines.com/zh-hans/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/',
        link1_2: '社会责任',
        link1_2_url: 'http://www.asc-wines.com/zh-hans/%E5%85%AC%E5%8F%B8%E6%A6%82%E8%BF%B0/%E4%BC%81%E4%B8%9A%E7%A4%BE%E4%BC%9A%E8%B4%A3%E4%BB%BB/',
        link1_3: '发展历程',
        link1_3_url: 'http://www.asc-wines.com/zh-hans/%E5%85%AC%E5%8F%B8%E6%A6%82%E8%BF%B0/%E6%88%91%E4%BB%AC%E7%9A%84%E9%A2%86%E5%AF%BC%E5%8A%9B/',
        link1_4: '核心团队',
        link1_4_url: 'http://www.asc-wines.com/zh-hans/%E6%A0%B8%E5%BF%83%E5%9B%A2%E9%98%9F/',

        title2: '我们的服务',
        link2_1: '葡萄酒活动',
        link2_1_url: 'http://www.asc-wines.com/zh-hans/%E6%88%91%E4%BB%AC%E7%9A%84%E6%9C%8D%E5%8A%A1/%E8%91%A1%E8%90%84%E9%85%92%E6%B4%BB%E5%8A%A8/',
        link2_2: '葡萄酒知识传授',
        link2_2_url: 'http://www.asc-wines.com/zh-hans/%E6%88%91%E4%BB%AC%E7%9A%84%E6%9C%8D%E5%8A%A1/asc%E8%91%A1%E8%90%84%E9%85%92%E6%95%99%E8%82%B2/',
        link2_3: '期酒',
        link2_3_url: 'http://www.asc-wines.com/zh-hans/%E6%88%91%E4%BB%AC%E7%9A%84%E6%9C%8D%E5%8A%A1/%E6%9C%9F%E9%85%92/',
        link2_4: '精品葡萄酒拍卖',
        link2_4_url: 'http://www.asc-wines.com/zh-hans/%E6%88%91%E4%BB%AC%E7%9A%84%E6%9C%8D%E5%8A%A1/asc%E7%B2%BE%E5%93%81%E8%91%A1%E8%90%84%E9%85%92%E6%8B%8D%E5%8D%96/',

        title3: '需要帮助',
        link3_1: '联系我们',
        link3_1_url: 'http://www.asc-wines.com/zh-hans/%E5%85%AC%E5%8F%B8%E6%A6%82%E8%BF%B0/%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC/',
        link3_2: '下载用户手册',
        link3_2_url: './image/ASC 电商平台使用指南.pdf',

        // aboutUS: '关于我们',
        // companyProfile: '公司简介',
        // socialResponsibility: '社会责任',
        // careerDevelopment: '职业发展',
        // termsConditions: '细则及条款',
        // shoppingHelp: '购物帮助',
        // payRelated: '支付相关',
        // modeDistribution: '配送方式',
        // returnWay: '退货方式',
        // invoiceRelevant: '发票相关',
        // needHelp: '需要帮助',
        // contactUs: '联系我们',
        // commonProblems: '常见问题',
        // shoppingGuide: '购物指南',
        followUs: '关注我们',
        weChat: '微信',
        sinaMicroblog: '新浪微博'
    },
    prompt: {
        successToast: '操作成功！',
        failToast: '操作失败，请稍后再试！',
        loginSuccessText: '登录成功！',
        loginFailText: '您的账户已被关闭，有任何疑问请联系您的销售经理',
        registerSuccessText: '注册成功！',
        pwdSuccessText: '密码修改成功，请重新登录！',
        orderInvalidText: '抱歉，此订单已失效，请重新下单！',
        agreementText: '请同意协议并勾选！',
        searchWordText: '请填写查询内容！',
        selectDeleteItemText: '请选择需要删除的物品！',
        selectTypeOfCompanyText: '请选择公司类型！',
        selectBusinessLicenseText: '请上传营业执照正面！',
        selectProvinceText: '请选择省！',
        selectCityText: '请选择市！',
        selectAreaText: '请选择区！',
        selectCardTypeText: '请选择证件类型！',
        selectIdCardPositiveText: '请上传身份证正面！',
        selectIdCardReverseText: '请上传身份证反面！',
        selectVoucherPhotoText: '请上传凭证照片！',
    }

    // toast// text: nb.model.get('prompt').successToast,//

};
nb.name('localization.cn', map);
module.exports = map;



//////////////////
// WEBPACK FOOTER
// ../src/js/localization/cn.js
// module id = 15
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39